module.exports = __webpack_public_path__ + "img/clock.6e89aa2e.svg";